import {
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Typography,
} from "antd";
import { animalExtendedApi, animalLogCrudApi } from "../client/EntityApi";
import CrudTable from "../core/component/crud/CrudTable";
import { useEffect, useState } from "react";
import { otherApi } from "../core/client/BaseEntityApi";
import { getAnimalLogCPColumns } from "../components/crud/AnimalLogCPComponents";
import CrudPageProcessButton from "../core/component/crud/CrudPageProcessButton";
import { useForm } from "antd/lib/form/Form";
import { Rules } from "../core/Rules";

const { Text } = Typography;

const animalLabels = {
  pregnant: "SAĞMAL GEBE HAYVAN",
  seminated: "SAĞMAL TOHUMLU HAYVAN",
  nonPregnant: "SAĞMAL BOŞ HAYVAN",
  fresh: "FRESH HAYVAN SAYISI",
  dry: "ERKEN KURU",
  closeup: "CLOSEUP (SON 21)",
  fcalf: "DİŞİ BUZAĞI",
  mcalf: "ERKEK BUZAĞI",
  msteer: "ERKEK DANA",
  msteer2: "ERKEK DANA 2",
  msteer3: "ERKEK DANA 3",
  bull: "BOĞA",
  bull2: "BOĞA 2",
  bull3: "BOĞA 3",
  bull4: "BOĞA 4",
  bull5: "BOĞA 5",
  bull6: "BOĞA 6",
  bull7: "BOĞA 7",
  pheifer: "GEBE DÜVE",
  sheifer: "TOHUMLU DÜVE",
  heifer: "BOĞAALTI DÜVE",
  fsteer: "DİŞİ DANA",
} as any;

const AnimalLogCrudPage = () => {
  const [form] = useForm();

  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const modalOnCancel = () => {
    form.resetFields();
    setLoading(false);
    setModalIsOpen(false);
  };

  useEffect(() => {
    otherApi.constants().then((response) => setMonths(response["months"]));
  }, []);

  return (
    <>
      <CrudTable
        entityLabel="Hayvan Envanter"
        api={animalLogCrudApi}
        searchKeys={["company.name"]}
        customSearchEntityLabel="İşletme Ara"
        hideDefaultRowProceses
        hideAddProcess
        columns={getAnimalLogCPColumns(months)}
        extraRowProcess={(row) => (
          <>
            <CrudPageProcessButton
              tooltipText="Rapor Oluştur"
              icon={<>R</>}
              onClick={() => {
                form.setFieldsValue({
                  companyId: row.company.id,
                  month: row.month,
                  year: row.year,
                });
                setModalIsOpen(true);
              }}
            />
          </>
        )}
        expandable={{
          expandedRowRender: (record: any) => (
            <div style={{ background: "#f5f5f5", padding: 24, maxWidth: 400 }}>
              <Row style={{ fontWeight: 600 }}>
                <Col span={16}>Hayvan Grubu</Col>
                <Col span={8} style={{ textAlign: "right" }}>
                  Adet
                </Col>
              </Row>

              <Divider style={{ margin: "8px 0 16px" }} />

              {Object.keys(animalLabels).map((key) => (
                <Row key={key} style={{ marginBottom: 12 }}>
                  <Col span={16}>
                    <Text>{animalLabels[key]}</Text>
                  </Col>

                  <Col span={8} style={{ textAlign: "right" }}>
                    <Text>{Number(record.animalData[key] || 0)}</Text>
                  </Col>
                </Row>
              ))}
            </div>
          ),
        }}
      />
      <Modal
        title="Rapor Oluştur"
        visible={modalIsOpen}
        okText="Oluştur"
        cancelText="Vazgeç"
        onCancel={modalOnCancel}
        onOk={() => {
          form.validateFields().then((values) => {
            setLoading(true);
            animalExtendedApi
              .createCompanyProfitabilityReport(values)
              .then((response) => {
                window.open(
                  process.env.REACT_APP_API_URL + response.url,
                  "_blank",
                  "noopener,noreferrer",
                );
              })
              .finally(() => modalOnCancel());
          });
        }}
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="companyId" rules={[Rules.required]} hidden>
            <Input hidden />
          </Form.Item>
          <Form.Item name="month" rules={[Rules.required]} hidden>
            <Input hidden />
          </Form.Item>
          <Form.Item name="year" rules={[Rules.required]} hidden>
            <Input hidden />
          </Form.Item>
          <Form.Item
            name="unitPrice"
            label="Birim Değer (TL)"
            rules={[Rules.required]}
            initialValue="0"
          >
            <InputNumber style={{ width: "100%" }} precision={2} min={0} />
          </Form.Item>
          <Form.Item
            name="animalSellGain"
            label="Hayvan Satış Geliri (Aylık TL)"
            rules={[Rules.required]}
            initialValue="0"
          >
            <InputNumber style={{ width: "100%" }} precision={2} min={0} />
          </Form.Item>
          <Form.Item
            name="milkPrice"
            label="Süt Fiyatı (Litre TL)"
            rules={[Rules.required]}
            initialValue="0"
          >
            <InputNumber style={{ width: "100%" }} precision={2} min={0} />
          </Form.Item>
          <Form.Item
            name="totalMilkAmount"
            label="Alınan Süt (Günlük Litre)"
            rules={[Rules.required]}
            initialValue="0"
          >
            <InputNumber style={{ width: "100%" }} precision={2} min={0} />
          </Form.Item>
          <Form.Item
            name="milchFeedCost"
            label="Sağılır Yem Gideri (Günlük TL)"
            rules={[Rules.required]}
            initialValue="0"
          >
            <InputNumber style={{ width: "100%" }} precision={2} min={0} />
          </Form.Item>
          <Form.Item
            name="milchCompanyCost"
            label="Sağılır İşletme Gideri (Günlük TL)"
            rules={[Rules.required]}
            initialValue="0"
          >
            <InputNumber style={{ width: "100%" }} precision={2} min={0} />
          </Form.Item>
          <Form.Item
            name="totalFeedCost"
            label="Toplam Yem Gideri (Günlük TL)"
            rules={[Rules.required]}
            initialValue="0"
          >
            <InputNumber style={{ width: "100%" }} precision={2} min={0} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AnimalLogCrudPage;
